import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isLoadingSelector, reloadSelector } from "../../selectors";
import {
  clearMonitoringQueueEntryDetails,
  getMonitoringQueueEntryDetails,
} from "../../actions";
import { useHistory, useLocation } from "react-router-dom";
import { Backdrop, CircularProgress, Modal } from "@material-ui/core";
import "./monitoringQueueEntryDetailsModal.css";
import { notifySuccess } from "../../../../actions";
import { CLIENT_SCORING_RESULT_MESSAGES } from "../../constants/clientScoringResultMessages";
import { NEGATIVE_MEDIA_IGNORING_PROPERTY_MESSAGES } from "../../constants/createNegativeMediaIgnotingPropertyMessages";
import { WATCHLIST_IGNORING_PROPERTY_MESSAGES } from "../../constants/watchListIgnoringPropertyMessages";
import DetailsModalContent from "./DetailsModalContent";
import { typeOptions } from "../../constants/monitoringQueueEntryConstants";
import { ModalHeader } from "reactstrap";
import CustomCloseModalButton from "../../../../components/common/CustomCloseModalButton";

const MonitoringQueueEntryDetailsModal = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const [openModal, setOpenModal] = useState(false);
  const [modalId, setModalId] = useState(null);
  const [type, setType] = useState(null);

  const isLoading = useSelector(isLoadingSelector);

  const {
    createIgnoringPropertySuccess,
    updateScoringSuccess,
    createNegativeMediaIgnoringPropertySuccess,
  } = useSelector(reloadSelector);

  useEffect(() => {
    if (modalId) {
      dispatch(clearMonitoringQueueEntryDetails());
      dispatch(getMonitoringQueueEntryDetails({ id: modalId }));
    }
  }, [modalId]);

  useEffect(() => {
    const id = modalId;
    if (updateScoringSuccess) {
      dispatch(notifySuccess(CLIENT_SCORING_RESULT_MESSAGES.SUCCESS));
      dispatch(getMonitoringQueueEntryDetails({ id }));
    } else if (createIgnoringPropertySuccess) {
      dispatch(notifySuccess(WATCHLIST_IGNORING_PROPERTY_MESSAGES.SUCCESS));
      dispatch(getMonitoringQueueEntryDetails({ id }));
    } else if (createNegativeMediaIgnoringPropertySuccess) {
      dispatch(
        notifySuccess(NEGATIVE_MEDIA_IGNORING_PROPERTY_MESSAGES.SUCCESS),
      );
      dispatch(getMonitoringQueueEntryDetails({ id }));
    }
  }, [
    createIgnoringPropertySuccess,
    updateScoringSuccess,
    createNegativeMediaIgnoringPropertySuccess,
  ]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const modalParam = searchParams.has("monitoringQueueEntryDetails");
    const idParam = searchParams.get("entryID");
    const typeOfCheck = searchParams.get("type");

    if (modalParam && idParam) {
      setOpenModal(true);
      setModalId(idParam);
      setType(typeOfCheck);
    } else {
      setOpenModal(false);
      setModalId(null);
      setType(null);
    }
  }, [location.search]);

  const handleCloseModal = () => {
    setOpenModal(false);
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete("monitoringQueueEntryDetails");
    searchParams.delete("entryID");
    searchParams.delete("type");

    history.push({ search: searchParams.toString() });
  };

  return <div>{openModal ? <RenderModal type={type} /> : null}</div>;

  function RenderModal({ type }) {
    return (
      <Modal
        disableScrollLock
        style={{ minWidth: 1000 }}
        open={modalId}
        onClose={handleCloseModal}
      >
        <div className="entry-modal-main-container">
          <ModalHeader
            close={<CustomCloseModalButton toggle={handleCloseModal} />}
          ></ModalHeader>
          <div className="entry-modal-content">
            <div style={{ paddingLeft: 80 }} className="font-weight-bold ">
              {type !== "null" && !isLoading
                ? "Input Parameters - " +
                  typeOptions.find((opt) => Number(opt.value) === Number(type))
                    .label
                : null}
            </div>
            <Backdrop
              style={{ borderRadius: 20, backgroundColor: "transparent" }}
              open={isLoading}
            >
              {isLoading ? (
                <CircularProgress style={{ color: "#0AD172" }} />
              ) : (
                "loaded"
              )}{" "}
            </Backdrop>
            <DetailsModalContent id={modalId} />
          </div>
        </div>
      </Modal>
    );
  }
};

export default MonitoringQueueEntryDetailsModal;



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/components/details-modal/MonitoringQueueEntryDetailsModal.jsx